(function() {
    window.c24.lp.ac.hav = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('hav');
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.hav.init();
    });

    const elements = document.querySelectorAll('.mod24ac.hav .widget');

    for (let j = 0; j < elements.length; j++) {
        new window.Vue({
            el: elements[j],
            data: {
                allApiData: {},
                producers: [],
                devices: [],
                selectedProducer: '',
                selectedDevice: '',
                showProducerOptions: false,
                showDeviceOptions: false,
                producerKeyword: '',
                deviceKeyword: '',
            },
            methods: {
                changeProducer: function(producer) {
                    if (!this.dataExists()) {
                        return '';
                    }

                    if (!this.allApiData[producer]) {
                        return;
                    }

                    this.blurProducer();

                    this.selectedProducer = producer;
                    this.producerKeyword = '';
                    this.devices = this.allApiData[producer];
                    this.selectedDevice = this.defaultDevice;
                },
                changeDevice: function(device) {
                    if (!this.dataExists()) {
                        return '';
                    }
                    this.blurDevice();
                    this.selectedDevice = device;
                    this.deviceKeyword = '';
                },
                filterProducerList: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    const keyword = this.producerKeyword;
                    const producers = Object.keys(this.allApiData);

                    this.producers = producers.filter(function(el) {
                        return el.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
                    });

                    if (this.producerKeyword.length > 0 && !(this.producers.indexOf(this.selectedProducer) !== -1) && this.producers.length != 0) {
                        this.selectedProducer = this.producers[0];
                        this.devices = this.allApiData[this.selectedProducer];
                        this.selectedDevice = this.defaultDevice;
                    }
                },
                filterDeviceList: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    const keyword = this.deviceKeyword;
                    const devices = this.allApiData[this.selectedProducer];
                    this.devices = devices.filter(function(el) {
                        return el[1].toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
                    });

                    if (this.deviceKeyword.length > 0 && !(this.devices.indexOf(this.selectedDevice) !== -1) && this.devices.length != 0) {
                        this.selectedDevice = this.devices[0];
                    }
                },
                nextProducer: function(event) {
                    if (!this.dataExists()) {
                        return '';
                    }
                    if (event.key === 'Enter') {
                        if (this.producerKeyword.length > 0 && !(this.producers.indexOf(this.selectedProducer) !== -1)) {
                            this.changeProducer(this.producers[0]);
                        } else {
                            this.changeProducer(this.selectedProducer);
                        }
                        this.showProducerOptions = false;
                        event.target.blur();
                        event.preventDefault;
                    }

                    if (this.showProducerOptions) {
                        const container = document.getElementById('producer');

                        if (container) {
                            const scrollHeight = container.scrollHeight / container.childElementCount;
                            const scrollTopHeight = container.scrollTop;
                            const index = this.producers.indexOf(this.selectedProducer);

                            if (event.key === 'ArrowUp' || event.key === 'Up') {
                                if (index != 0) {
                                    this.selectedProducer = this.producers[index - 1];
                                    container.scrollBy(0, -scrollHeight);
                                } else {
                                    this.selectedProducer = this.producers[this.producers.length - 1];
                                    container.scrollBy(0, container.scrollHeight);
                                }
                            } else if (event.key === 'ArrowDown' || event.key === 'Down') {
                                if (index != (this.producers.length - 1)) {
                                    this.selectedProducer = this.producers[index + 1];
                                    container.scrollBy(0, scrollHeight);
                                } else {
                                    this.selectedProducer = this.producers[0];
                                    container.scrollBy(0, -scrollTopHeight);
                                }
                            }
                        }
                        this.devices = this.allApiData[this.selectedProducer];
                        this.changeDevice(this.defaultDevice);
                    }
                },
                nextDevice: function(event) {
                    if (!this.dataExists()) {
                        return '';
                    }
                    if (event.key === 'Enter') {
                        if (this.deviceKeyword.length > 0) {
                            this.changeDevice(this.devices[0]);
                        }
                        this.showDeviceOptions = false;
                        event.target.blur();
                        event.preventDefault;
                    }
                    if (this.showDeviceOptions) {
                        const container = document.getElementById('device');

                        if (container) {
                            const scrollHeight = container.scrollHeight / container.childElementCount;
                            const scrollTopHeight = container.scrollTop;
                            const index = this.devices.indexOf(this.selectedDevice);

                            if (event.key === 'ArrowUp' || event.key === 'Up') {
                                if (index != 0) {
                                    this.selectedDevice = this.devices[index - 1];
                                    container.scrollBy(0, -scrollHeight);
                                } else {
                                    this.selectedDevice = this.devices[this.devices.length - 1];
                                    container.scrollBy(0, container.scrollHeight);
                                }
                            } else if (event.key === 'ArrowDown' || event.key === 'Down') {
                                if (index != (this.devices.length - 1)) {
                                    this.selectedDevice = this.devices[index + 1];
                                    container.scrollBy(0, scrollHeight);
                                } else {
                                    this.selectedDevice = this.devices[0];
                                    container.scrollBy(0, -scrollTopHeight);
                                }
                            }
                        }
                    }
                },
                isElementInViewport: function() {
                    const widget = this.$root.$el;
                    const rect = widget.getBoundingClientRect();

                    if (
                        !(rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
                        )) {
                        this.blurProducer();
                        this.blurDevice();
                    }
                },
                checkForm: function(e) {
                    if (!this.dataExists()) {
                        return '';
                    }
                    if (!this.selectedProducer) {
                        e.preventDefault();
                    }

                    if (!this.selectedDevice) {
                        e.preventDefault();
                    }
                },
                blurProducer: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    const inputTargets = document.getElementsByClassName('producer');

                    for (let i = 0; i < inputTargets.length; i++) {
                        inputTargets[i].blur();
                    }

                    this.showProducerOptions = false;
                    this.producerKeyword = '';
                    this.producers = Object.keys(this.allApiData);
                },
                blurDevice: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    const inputTargets = document.getElementsByClassName('device');

                    for (let i = 0; i < inputTargets.length; i++) {
                        inputTargets[i].blur();
                    }

                    this.showDeviceOptions = false;
                    this.deviceKeyword = '';
                    this.devices = this.allApiData[this.selectedProducer];
                },
                dataExists: function() {
                    if (this.allApiData.length === 0) {
                        return false;
                    } else {
                        return true;
                    }
                },
            },
            computed: {
                cutProducer: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    if (this.selectedProducer.length === 0) {
                        return '';
                    }

                    if (this.selectedProducer.length > 23) {
                        return this.selectedProducer.substring(0, 23) + ' ...';
                    } else {
                        return this.selectedProducer;
                    }
                },
                cutDevice: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    if (this.selectedDevice.length === 0) {
                        return '';
                    }

                    if (this.selectedDevice[1].length > 23) {
                        return this.selectedDevice[1].substring(0, 23) + ' ...';
                    } else {
                        return this.selectedDevice[1];
                    }
                },
                separator: function() {
                    if (this.producers.indexOf('Huawei') > -1) {
                        return 'Huawei';
                    } else if (this.producers.indexOf('Samsung') > -1) {
                        return 'Samsung';
                    } else if (this.producers.indexOf('Apple') > -1) {
                        return 'Apple';
                    } else {
                        return null;
                    }
                },
                deviceValue: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    return this.selectedDevice[0];
                },
                error: function() {
                    if (!this.dataExists()) {
                        return 'Leider ist etwas schief gelaufen.';
                    }
                    if (Array.isArray(this.producers) && this.producers.length === 0) {
                        return 'Es wurden keine Hersteller gefunden.';
                    }
                    if (Array.isArray(this.devices) && this.devices.length === 0) {
                        return 'Es wurden keine Modelle gefunden.';
                    }
                    return '';
                },
                defaultDevice: function() {
                    if (!this.dataExists()) {
                        return '';
                    }
                    for (let i = 0; i < this.devices.length; i++) {
                        if (this.devices[i].indexOf(1) !== -1) {
                            return this.devices[i];
                        }
                    }
                    return '';
                },
            },
            mounted: function() {

                window.c24LpInitializeFixables(this.$el.closest('.mod24ac'));

                if (!window.c24LpIsMobile) {
                    window.c24.lp.ac.initGenericTooltips('hav');
                }

                document.addEventListener('keyup', this.nextProducer);
                document.addEventListener('keyup', this.nextDevice);
                document.addEventListener('scroll', this.isElementInViewport);
            },
            created: function() {
                this.allApiData = JSON.parse(elements[j].dataset.aurumMapping);
                this.producers = Object.keys(this.allApiData);
                this.changeProducer('Apple');
            },
            watch: {
                producerKeyword: {
                    handler(newValue) {
                        if (newValue.length > 0) {
                            this.changeProducer(newValue);
                        }
                    },
                    immediate: true,
                },
                deviceKeyword: {
                    handler(newValue) {
                        if (newValue.length > 0) {
                            const newDevices = this.devices.filter(function(el) {
                                const deviceName = el[1].toLowerCase();

                                return newValue.toLowerCase().split(' ').every(function(word) {
                                    return deviceName.includes(word);
                                });
                            });
                            if (newDevices.length === 1) {
                                this.changeDevice(newDevices[0]);
                            }
                        }
                    },
                    immediate: true,
                },
            },
        });
    }
})();
